export const ADMIN = "ADMIN";
export const USER = "USER";
export const MASTER = "MASTER";
export const EMPLOYEE = "EMPLOYEE";
